export const parseDate = (dateString: string) => {
  if (dateString === null) return undefined;
  const find = dateString.match(/(?<=\/Date\().*(?=\))/g);
  if (find != null) {
    return new Date(parseInt(find[0], 10));
  }
  return undefined;
};
